import { z } from 'zod';

const ImagePerLanguageSchema = z.object({
  language: z.string(),
  imageLink: z.string(),
  imageLinkDark: z.string().optional(),
  _id: z.string()
});

const PromotionDeviceSchema = z.object({
  defaultImageLink: z.string(),
  defaultImageLinkDark: z.string().optional(),
  imagesPerLanguage: z.array(ImagePerLanguageSchema)
});

const SettingsPerCurrencySchema = z.object({
  _id: z.string().optional(),
  currency: z.string(),
  tournamentPrize: z.string().optional(),
  desktop: z.object({
    imageLink: z.string().optional(),
    imageLinkDark: z.string().optional(),
    imagesPerLanguage: z.array(ImagePerLanguageSchema).optional()
  }),
  tablet: z.object({
    imageLink: z.string().optional(),
    imageLinkDark: z.string().optional(),
    imagesPerLanguage: z.array(ImagePerLanguageSchema).optional()
  }),
  mobile: z.object({
    imageLink: z.string().optional(),
    imageLinkDark: z.string().optional(),
    imagesPerLanguage: z.array(ImagePerLanguageSchema).optional()
  })
});

const PromotionPageItemSchema = z.object({
  item: z.string(),
  snippetId: z.string().optional()
});

const LeaderboardPrizeSchema = z.object({
  prizeTranslationKey: z.string(),
  placeFrom: z.number(),
  placeTo: z.number()
});

export const PromotionSchema = z.object({
  _id: z.string(),
  promoId: z.string(),
  type: z.string(),
  triggerType: z.string().optional(),
  enabled: z.boolean(),
  tournamentId: z.string().nullable().optional(),
  showTakePart: z.boolean(),
  tags: z.array(z.string()),
  showTimerInsteadPeriod: z.boolean(),
  titleTranslationKey: z.string(),
  actionLink: z.string().optional(),
  periodStart: z.string(),
  periodEnd: z.string(),
  showFrom: z.string(),
  showTo: z.string(),
  defaultDescriptionTranslationKey: z.string().optional(),
  defaultDescriptionSnippetId: z.string().optional(),
  settingsPerCurrency: z.array(SettingsPerCurrencySchema).optional(),
  promotionPageItems: z.array(PromotionPageItemSchema),
  mayBeInterestedIn: z
    .array(
      z.object({
        promoId: z.string()
      })
    )
    .optional(),
  leaderboardPrizes: z.array(LeaderboardPrizeSchema).optional(),
  desktop: PromotionDeviceSchema,
  tablet: PromotionDeviceSchema,
  mobile: PromotionDeviceSchema,
  endTime: z.string().nullable().optional(),
  startTime: z.string().nullable().optional(),
  setSchedule: z.boolean().optional(),
  daysOfWeek: z.array(z.string()).optional(),
  period: z.string().optional(),
  repeatEvery: z.number().optional(),
  showDateWhenActive: z.boolean().optional()
});

export const PromotionsSchema = z.array(PromotionSchema);
